import {type ActionTree} from 'vuex';

const actions: ActionTree<ModuleCalendarState, RootState> = {
    setFindButtonVisibility({commit}, value: boolean)
    {
        commit('setFindButton', value);
    },
    setEventCourseEnabled({commit}, value: boolean)
    {
        commit('setEventCourseEnabled', value);
    },
    setNotifyClients({commit}, value: number)
    {
        commit('setNotifyClients', value);
    },
};

export default actions;